import React from 'react';
import { numFormatter } from '../../../../../core/utils/number';
import HdIcon from '../../../../../media/components/icon/HdIcon';
import { ActivationRunStageEnum } from '../../../ActivationSyncHistory/models/run-stages';
import { ActivationStatsDataPoint } from '../../../ActivationSyncHistory/models/stats-data';
import { StatsRunStageInfo } from '../../../ActivationSyncHistory/models/stats-run-stage';

interface ActivationStatsToolTipProps {
  dataPoint: ActivationStatsDataPoint;
  runStageInfo: StatsRunStageInfo;
}

export default function ActivationStatsTooltip({
 dataPoint,
 runStageInfo
}: ActivationStatsToolTipProps) {
  const isRunStageTransformation = runStageInfo?.value === ActivationRunStageEnum.TRANSFORMATION;

  return (
    <div className='stats-info-container'>
      {dataPoint.total || (!dataPoint.total && !dataPoint.failed) ? (
        <div className='center-flex-row py-1'>
          <span className='text-caption-1 mr-1'>
            Successful Events:
          </span>

          <span className='text-bold'>
            {numFormatter(dataPoint.total)}
          </span>
        </div>
      ) : <></>}

      {(isRunStageTransformation && dataPoint.total) ? (
        <div className='center-flex-row py-1'>
          <div className='flex-col px-3 flex-1'>
            <span className='text-caption-2 text-secondary'>
              New Events
            </span>

            <span className='text-bold'>
              {numFormatter(dataPoint.total - dataPoint.retry)}
            </span>
          </div>

          <div className='flex-col px-3 flex-1'>
            <span className='text-caption-2 text-secondary'>
              Retried Events
            </span>

            <span className='text-bold'>
              {numFormatter(dataPoint.retry)}
            </span>
          </div>
        </div>
      ) : <></>}

      {dataPoint.failed ?
        <div className='center-flex-row py-1'>
          <span className='text-caption-1 mr-1'>
            Failed Events:
          </span>

          <span className='text-bold'>
            {numFormatter(dataPoint.failed)}
          </span>
        </div> : <></>}

      <div className='text-caption-1 center-flex-row py-1'>
        <HdIcon name='time' className='mr-1 clock-icon' />

        <span>
          {dataPoint.timeDisplay}
        </span>
      </div>
    </div>
  );
}
